/*
semsomi AB
Copyright (c) 2016-2017
All rights reserved
*/

import * as types from './actionTypes';
import { CALL_API } from '../middlewares/api'

export function setFocusedPuff(id, puff, options) {
  return {
    type: types.SET_FOCUSED_PUFF,
    id,
    puff,
    options	
  };
}

export function sendPuff(id, to) {
  return {[CALL_API]: {
            endpoint: 'sendpuff',
            method:"POST",
            body:{
            	id: id,
            	to: to
            },
            types: [types.SENDPUFF_REQUEST, types.SENDPUFF_SUCCESS, types.SENDPUFF_FAILURE]
          }}   
}



export function savePuff(id, puff) {
  // console.log('ACTION')
  return {[CALL_API]: {
            endpoint: 'update',
            method:"POST",
            body:{
            	id: id,
            	puff: puff
            },
            types: [types.SAVEPUFF_REQUEST, types.SAVEPUFF_SUCCESS, types.SAVEPUFF_FAILURE]
          }}   
}

export function orderPuff(id, status, options) {
  // console.log('ACTION')
  return {[CALL_API]: {
            endpoint: 'order',
            method:"POST",
            body:{
              id: id,
              status: status,
              options: options
            },
            types: [types.ORDERPUFF_REQUEST, types.ORDERPUFF_SUCCESS, types.ORDERPUFF_FAILURE]
          }}   
}


export function buyPuff(id) {
  // console.log('ACTION')
  return {[CALL_API]: {
            endpoint: 'buy',
            method:"POST",
            body:{
            	id: id
            },
            types: [types.BUYPUFF_REQUEST, types.BUYPUFF_SUCCESS, types.BUYPUFF_FAILURE]
          }}   
}

export function buildPuff(id, plugins, targetFeed, body) {
  // console.log('ACTION')
  return {[CALL_API]: {
            endpoint: 'build',
            method:"POST",
            body:{
            	id: id,
            	plugins:plugins,
            	targetFeed: targetFeed,
              ...(body ? body : {})
            },
            types: [types.BUILDPUFF_REQUEST, types.BUILDPUFF_SUCCESS, types.BUILDPUFF_FAILURE]
          }}   
}